import { render, staticRenderFns } from "./NDashboardSideMenu.vue?vue&type=template&id=3c31c690&"
import script from "./NDashboardSideMenu.vue?vue&type=script&lang=js&"
export * from "./NDashboardSideMenu.vue?vue&type=script&lang=js&"
import style0 from "./NDashboardSideMenu.vue?vue&type=style&index=0&scooped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports